import { render } from "./FeaturesBanner.vue?vue&type=template&id=5afc62f5"
import script from "./FeaturesBanner.vue?vue&type=script&lang=js"
export * from "./FeaturesBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__